import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom'
import Button from '../components/Button'

function About() {
  const today = new Date()

  const month = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]

  return (
    <div className='my-24'>
      <h1 className='text-4xl mb-6 text-center font-medium hover:text-sky-600'>
        You are using <br />
        <strong>Plamar USA</strong>
        <br /> partial slabs list
        <p className='container mx-auto w-1/4 border-b-2 my-6'> </p>
        <p className='text-xl text-gray-600'>This list is updated.</p>
        <p className='text-xl text-gray-600'>
          Search for the brand and color you need
        </p>
        <p className='text-xl text-gray-600'>Call us to buy the piece</p>
        <p className='text-xl text-gray-600'>or have us cut and fabricate</p>
        <br />
        <p className='text-sm text-gray-400'>
          List Updated: {month[today.getMonth()]} {today.getDate()},{' '}
          {today.getFullYear()}
          {console.log(today)}
        </p>
      </h1>
    </div>
  )
}

export default About
